import React from 'react';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import MoreNavBarIcon from '@cp/src/assets/icons/MoreNavBarIcon';
import SidebarLinks from '../SideNavigationPanel/SidebarLinks';
import { NavigationItemsProps } from './interface';

export const MoreNavigationItem = (props: NavigationItemsProps) => {
  const { items, pathname, search, linkClickHandler } = props;
  return (
    <SidebarLinks
      key="more"
      activeIcon={<MoreNavBarIcon />}
      inActiveIcon={<MoreNavBarIcon />}
      name="More"
      route=""
      subRoute=""
      linkClickHandler={linkClickHandler}
      currentPathname={pathname}
      currentSearch={search}
      clickStreamEvent={CLICKSTREAM_EVENT_NAMES.LH_ALL_AGENTS_SIDE_PANEL_CLICK}
      moreMenuItems={items.map(item => ({
        ...item,
        activeIcon: React.cloneElement(item.activeIcon, { width: 16, height: 16 }),
        inActiveIcon: React.cloneElement(item.inActiveIcon, { width: 16, height: 16 })
      }))}
    />
  );
};

export default MoreNavigationItem;
